module.exports = __webpack_public_path__ + "static/media/wheel-turaanadaa.3726c206.png";